import { INSTANT_TAX_CREDIT_HELP_LINK } from '../constants/urls';

// Common
export const ROOT_PATH = 'root';

// Instant credit tax funnel
export const INSTANT_TAX_CREDIT_HOW_IT_WORKS = 'InstantTaxCreditHowItWorks';
export const INSTANT_TAX_CREDIT_USER_ADDRESS = 'InstantTaxCreditUserAddress';
export const INSTANT_TAX_CREDIT_USER_BANK_INFO = 'InstantTaxCreditUserBankInfo';
export const INSTANT_TAX_CREDIT_USER_INFO = 'InstantTaxCreditUserInfo';

export type RoutePath =
  | typeof ROOT_PATH
  | typeof INSTANT_TAX_CREDIT_HOW_IT_WORKS
  | typeof INSTANT_TAX_CREDIT_USER_ADDRESS
  | typeof INSTANT_TAX_CREDIT_USER_BANK_INFO
  | typeof INSTANT_TAX_CREDIT_USER_INFO;

const ROUTES = {
  [ROOT_PATH]: '/',
  [INSTANT_TAX_CREDIT_HOW_IT_WORKS]: '/comment-ca-marche',
  [INSTANT_TAX_CREDIT_USER_ADDRESS]: '/mon-domicile',
  [INSTANT_TAX_CREDIT_USER_BANK_INFO]: '/mes-infos-bancaires',
  [INSTANT_TAX_CREDIT_USER_INFO]: '/mes-coordonnees',
};

export const route = (path: RoutePath) => ROUTES[path];

type ITCFunnelScreen = {
  helpLink?: string;
  withBackButton?: boolean;
  screenName: RoutePath;
  isEntryScreenForFunnel?: boolean;
};

export const SCREENS: Record<string, ITCFunnelScreen> = {
  [route('root')]: {
    screenName: 'root',
  },
  [route(INSTANT_TAX_CREDIT_HOW_IT_WORKS)]: {
    helpLink: INSTANT_TAX_CREDIT_HELP_LINK,
    screenName: 'InstantTaxCreditHowItWorks',
    isEntryScreenForFunnel: true,
  },
  [route(INSTANT_TAX_CREDIT_USER_ADDRESS)]: {
    helpLink: INSTANT_TAX_CREDIT_HELP_LINK,
    withBackButton: true,
    screenName: 'InstantTaxCreditUserAddress',
    isEntryScreenForFunnel: true,
  },
  [route(INSTANT_TAX_CREDIT_USER_INFO)]: {
    helpLink: INSTANT_TAX_CREDIT_HELP_LINK,
    withBackButton: true,
    screenName: 'InstantTaxCreditUserInfo',
  },
  [route(INSTANT_TAX_CREDIT_USER_BANK_INFO)]: {
    helpLink: INSTANT_TAX_CREDIT_HELP_LINK,
    withBackButton: true,
    screenName: 'InstantTaxCreditUserBankInfo',
  },
};
